export default __webpack_public_path__ + "static/media/closeBtn.8d1c01a9.svg";